import React, { Fragment, useState, useEffect } from 'react';
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/plan-page.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { GetPlanDetails, GetPlanCovers } from '../../api/selfserve';
import ReopenRequestAlert from './ReopenRequestModal';
import { OpenRequestAlert } from './OpenRequestModal';
import ActivationAlert from './ActivationRequiredModal';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import {
    changeProgress,
    updateSelectedPlan,
    planCoversFetched,
    updateSelectedCover,
    changeTrackerState,
    changeIssuePageFrom,
    updateAppointmentDate,
    changeAddressPageFrom,
    updateAddressDetails,
    updateWhatsappCheck,
    updateMultipleEnabled,
    updateParentDeviceDetails,
    updateIsServicePgChargesApplicable,
} from '../../redux/actions/selfserveActions';
import {  BLOCKED_CHANNELS, isBrandBlocked, getBrandFromModel } from '../../utils/selfserve';
import { ContactUs } from './ContactUsModal';
import { selectPlan, planNotFoundClick, planPageModal } from '../../tracking/selfserveTracking';
import { HOMECARE_PLANS, HOMECARE_PREMIUM_PRODUCTS,HOMECARE_PLAN_LIST, HOMECARE_FEST_MAX_CLAIMS } from '../../constants/index';
import Image from '../common/Image';
import { notFindMyPlanClicked } from '../../tracking/segment/loginPage';
import { getStaticPath } from '../../utils';
import { capitalize } from '../../utils/index'
import {  raiseServiceRequestPressed } from '../../tracking/segment/selfservePage';

// interface PlanCard {
//     onClick: (e: React.MouseEvent) => void,
//     style?: object,
//     className?: string | null,
//     children?: React.ReactNode,
//     disabled?: boolean,
//     plan: any,
//     key: any,
//     is_selected: Boolean,
//     index: number
// }

// interface ChildPlanCard {
//     onClick:(e: React.MouseEvent) => void,
//     style?: object,
//     className?: string | null,
//     children?: React.ReactNode,
//     disabled?: boolean,
//     childPlan: any,
//     key: any,
//     is_selected: Boolean,

// }

// interface ReduxStateProps {
//     selfserveReducer: any,
//     setPageLoading: (data:Boolean) => void,
//     customerExists: boolean,
//     cart: any
// }

// interface MainProps{
//     subIssues: any
// }

// type Props = ReduxStateProps & MainProps;

const PlanPage = (props:any) => {

    const dispatch:any = useDispatch();
    const [disableBtn, setDisableBtn] = useState<boolean>(props.selfserveReducer.planDetails.hasOwnProperty('button_disabled') ? props.selfserveReducer.planDetails.button_disabled : true);
    const { parentPlanDetails, editScreen, multiple_enabled } = props.selfserveReducer
    useEffect(() => {
        if(props.selfserveReducer.userPlans){
            dispatch(changeTrackerState(2));
            window.scrollTo({top:0,left:0,'behavior': 'smooth'});
            dispatch(changeIssuePageFrom(3));
            dispatch(changeAddressPageFrom(3));
        }else{
            props.setPageLoading(true);
        }


    }, [])

    // Getting Fetched Plans from Redux Store
    const plans = props.selfserveReducer.userPlans;

    // const disableBtn = props.selfserveReducer.planDetails;


    const [isActiveSR, changeIsActiveSR] = useState(false);

    const [reopenEligibleSR, changeReopenEligibleSR] = useState(false)

    const [activeSRRefNo, setActiveSRRefNo] = useState(props.selfserveReducer.planDetails.hasOwnProperty('sr_id') ? props.selfserveReducer.planDetails.sr_id : '')

    // Copay Modal States
    const [isCopayPlan, setIsCopayPlan] = useState(props.selfserveReducer.planDetails.hasOwnProperty('is_copay') ? true : false);
    const [planName, setPlanName] = useState(props.selfserveReducer.planDetails.hasOwnProperty('plan_title') ? props.selfserveReducer.planDetails.plan_title : '');

    // Plan Not Activated States
    const [activePlan, setActivePlan] = useState(false);

    // Contact-Us Modal
    const [writeToUs, setWriteToUs] = useState(false);

    // IF Covers available on selected plan is more than 1 will display covers page
    const [coversNo, setCoversNo] = useState(props.selfserveReducer.planCovers.length);
    const [selectedOsid, setSelectedOsid] = useState('')

    //Getting Fetched covers from Redux store
    const planCovers = props.selfserveReducer.planCovers


    // Handles when click on Plan Card
    const handleClick = (item) => {
        setSelectedOsid(item.osid)
        //use for mutipleSR creation flag set in redux true
        if(!multiple_enabled && HOMECARE_PLAN_LIST.includes(item.plan_name)){
            dispatch(updateMultipleEnabled(true));
        }else if(multiple_enabled && !HOMECARE_PLAN_LIST.includes(item.plan_name)){
            dispatch(updateMultipleEnabled(false));
        }


        if (HOMECARE_PREMIUM_PRODUCTS.includes(item.plan_name)) {
            setDisableBtn(false)
        }
        if (item.id !== props.selfserveReducer.planDetails.id && !HOMECARE_PREMIUM_PRODUCTS.includes(item.plan_name)) {

            // Enabling & Disabling Next Button
            let btn;
            //we check that scenario in child page for HC plan
            if (!HOMECARE_PLAN_LIST.includes(item.plan_name)) {
                if (item.reopen_eligible && item.covers > 1) {
                    btn = false;
                }
                else if (!['Active', 'Under Brand Warranty'].includes(item.plan_status) || (item.active_sr_exists)) {

                    // Disable Button here
                    btn = true;

                } else {

                    // Enable Button Here
                    if (item.reopen_eligible && item.covers === 1) {
                        btn = true
                    } else {
                        btn = false;
                    }
                    // btn = false;

                }
            }else{
                btn = false
            }
            // If Clicked Plan is Not already Selected
            props.setPageLoading(true);
            setPlanName(item.plan_title);
            setCoversNo(item.covers);
            setIsCopayPlan(item.is_copay);

            const data = {
                "token_id": props.selfserveReducer.token_id,
                "osid": item.osid
            }
            GetPlanDetails(item.tokenized_osid, {

                "application": "website",
                "data": JSON.stringify(data)

            }).then((res: any) => {
                const response = res.data;
                const oldData = response.old_data;

                setActiveSRRefNo(response.sr_id)
                response['button_disabled'] = btn;
                setDisableBtn(btn);
                dispatch(updateSelectedPlan((response)));

                // Updating address with oldData values if exist
                if (oldData.hasOwnProperty('old_order')) {
                    if (oldData.old_order.address.pincode) {
                        const addressData = {
                            address: { address: oldData.old_order.address.address, address2: oldData.old_order.address.address_line2, pincode: oldData.old_order.address.pincode, city: oldData.old_order.address.city, state: oldData.old_order.address.state }
                        }
                        dispatch(updateAddressDetails(addressData))
                    }
                }else {
                    const temp_address = response?.order?.address ? response?.order?.address : {}
                    const addressData = {
                        address: {
                            address : temp_address?.address,
                            address2 : temp_address?.address2,
                            pincode : temp_address?.pincode,
                            city : temp_address?.city,
                            state : temp_address?.state,

                        }
                    }
                    dispatch(updateAddressDetails(addressData));
                }

                // Whatsapp Opt in Initial State
                dispatch(updateWhatsappCheck(response.can_opt_in_whatsapp));
                const deviceId = res.data.device_detail ? res.data.device_detail.device_id : null
                // if (deviceId) {
                    GetPlanCovers({

                        "application": "website",
                        "data": JSON.stringify(data)

                    }).then((covers: any) => {
                        if (covers) {
                            dispatch(updateIsServicePgChargesApplicable(covers?.data?.is_service_pg_charges_applicable || false))
                            if (deviceId && covers.data && covers.data.hasOwnProperty(deviceId)) {
                                dispatch(planCoversFetched(covers.data[deviceId]));
                                if (item.covers === 1) {
                                    dispatch(updateSelectedCover({ index: 0, selectedCover: covers.data[deviceId] }));
                                }
                            } else if (HOMECARE_PLANS.includes(item.plan_name)) {
                                dispatch(planCoversFetched(covers.data.device));
                            }

                            props.setPageLoading(false);
                        }
                    })
            })

            // Resetting the Appointment Dates
            const appointmentData = {
                appointment_date_1: null,
                appointment_date_2: null,
                appointment_slot_1: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
                appointment_slot_2: (new Date().getHours() < 14) ? "10AM - 2PM" : "2PM - 6PM",
            }
            dispatch(updateAppointmentDate(appointmentData));
        }

        //update current plan details
        const parentPlanDetails = item
        parentPlanDetails["button_disabled"] = true
        dispatch(updateParentDeviceDetails(parentPlanDetails));


        if (!HOMECARE_PLAN_LIST.includes(item.plan_name)) {
            // check this part for deactivate plan scenario and all scenario
            // Sr reopen case
            if (item.reopen_eligible && item.covers === 1) {
                changeReopenEligibleSR(true)
                planPageModal('Reopen SR Modal', 'Plan Page'); //gtm tracking event

            } else if (item.active_sr_exists) {
                planPageModal('Active SR Modal', 'Plan Page'); //gtm trackign event
                changeIsActiveSR(true);

            } else if (!item.is_registered && !(['Active', 'Under Brand Warranty'].includes(item.plan_status))) {
                planPageModal('Activate Plan Modal', 'Plan Page'); //gtm trackign event
                setActivePlan(true)

            }
        }

    }

    // Helper Fucntion to decide which plan to Disable
    const isPlanActive = (item) => {
        if (HOMECARE_PREMIUM_PRODUCTS.includes(item.plan_name)) {
            return false
        }
        if (item.blacklisted) {
            return true
        }
        if(isBrandBlocked(item)) {
            return true
        }
        if(BLOCKED_CHANNELS.includes(item.channel_name)){

            return true

        }
        else if (!item.plan_validity.is_valid) {

            // if (item.reopen_eligible || item.active_sr_exists || item.plan_status == 'Activation Pending') {
            if (item.reopen_eligible || item.active_sr_exists ||  ['Activation Pending', 'Pending Activation', 'Unknown'].includes(capitalize(item.plan_status))) {
                return false
            } else {
                return true
            }

        } else if ( item.plan_status == 'Cancelled') {

            return true

        }else if ( item.plan_title == 'Instarepair' && ['Lapsed', 'Consumed', 'Expired'].includes(item.plan_status)) {

            return true

        }
         else if (HOMECARE_PLANS.includes(item.plan_title)) {

            return false
        }
        else if ( item.plan_name == 'Instarepair' && item.plan_status == 'Active' && !item.active_sr_exists) {
            return true
        }
         else {
            return false
        }
    }

    // Handles the logic For NEXT Button
    const handlebutton = () => {
        selectPlan(); //gtm tracking event

        if (HOMECARE_PLAN_LIST.includes(parentPlanDetails.plan_name)) {
            dispatch(changeProgress(14));
        }
        else if(isCopayPlan){
            dispatch(changeProgress(4));
            raiseServiceRequestPressed({step:'1 of 4',osid: selectedOsid,'plan_name':planName})
        }
        else if (coversNo > 1) {
            dispatch(changeProgress(4));
            raiseServiceRequestPressed({step:'1 of 4',osid: selectedOsid,'plan_name':planName})
        }
        else if (coversNo == 1 && planCovers[0].type == "service") { //only for PMAC plan
            dispatch(changeProgress(4));
            raiseServiceRequestPressed({step:'1 of 4',osid:selectedOsid,'plan_name':planName})
        }
        else {
            dispatch(changeProgress(5));
            raiseServiceRequestPressed({'step':'1 of 3',osid:selectedOsid,'plan_name':planName})
        }
    }

    return (

        <div className={styles.plan_parent}>

            {plans && <div className={`${styles.top_link} row`}>
                <h5 className='col-12 col-md-6'>Choose Plan</h5>
                <a className='col-12 col-md-6' onClick={(e) => { e.preventDefault();dispatch(changeProgress(6)); notFindMyPlanClicked({'phone':props.selfserveReducer.mobileNumber}) ; planNotFoundClick();}} href=''>I don't find my plan in the list</a>
            </div>}

            <div className={styles.card_holder}>

                {plans && plans.map((item, index) => {item.reopen_eligible || item.active_sr_exists
                  return (<PlanCard
                      disabled={isPlanActive(item)}
                      onClick={() => { handleClick(item) }}
                      plan={item} key={item.id}
                      is_selected={parentPlanDetails.id === item.id ? true:false}
                      index={index}
                  />)
                })}

            </div>

            <div className={commonStyles.button_actions_sticky} data-varient='sticky' id="bottom-sticky-header">
                {/* PREVIOUS BUTTON */}
                {/* {
                !props.customerExists && <Button
                    disabled={false}
                    className={commonStyles.cart_btn}
                    text={'Previous'}
                    variant='secondary'
                    onClick={() => {
                        dispatch(changeProgress(1));
                    }}
                    />
                } */}


                <Button
                    disabled={disableBtn}
                    className={commonStyles.cart_btn}
                    text={!editScreen.isEditing ? 'Next' : 'Done'}
                    variant='primary'
                    onClick={() => { handlebutton() }}
                />

            </div>
            {/* Modals */}
            <ReopenRequestAlert is_open={reopenEligibleSR} closeModal={changeReopenEligibleSR}  planDetail={props.selfserveReducer.planDetails} osid={selectedOsid}/>

            <OpenRequestAlert is_open={isActiveSR} closeModal={changeIsActiveSR} refNo={activeSRRefNo} planDetail={props.selfserveReducer.planDetails} osid={selectedOsid} setPageLoading={props.setPageLoading} category={props.selfserveReducer.deviceDetails?.category}/>

            <ActivationAlert is_open={activePlan} closeModal={setActivePlan} activation_link={props.selfserveReducer.planDetails.activation_link} osid={selectedOsid}/>

            <ContactUs is_open={writeToUs} closeModal={setWriteToUs} subIssues={props.subIssues} />
        </div>
    )
}

const PlanCard = (props: any) => {
    const plan = props.plan
    const statusMapping = {
        'Plan Not Started': 'Onsitego Plan is Not Started',
        'Inspection Pending': 'Device Inspection is Pending',
        'Active': 'Onsitego Plan is Active',
        'Under Brand Warranty': 'Device is Under Brand Warranty',
        'Expired': 'Onsitego Plan is Expired',
        'Pending Activation': 'Onsitego Plan Activation is Pending',
        'Consumed': 'Onsitego Plan is Consumed',
        'Cancelled': 'Onsitego Plan is Cancelled',
        'Unknown': 'Onsitego Plan Activation is Pending',
        'Lapsed': 'Onsitego Plan is lapsed',
        'Activation Pending': 'Onsitego Plan Activation is Pending',

    }
    const isWpAmcLite = (plan) => {
      if (plan.category_type === "Water Purifier" && plan.plan_name === "AMC LITE") {
        return true;
      }
      return false;
    }
    const getDetailsComponent = (plan) => {

        //Default value
        let status = (<div className={styles.plan_details}>
            { ['Consumed', 'Lapsed'].includes(plan.plan_status) ?
              ( plan.reopen_eligible ?
                <><span>Details:</span> <p>Available for Reopen, within 30 days of SR Completion</p> </>
                :
                <>
                  {!isWpAmcLite(plan) && 
                    <>
                      <span>Details:</span> <p>Not available for Reopen, Crossed 30 days after SR Completion</p>
                    </>
                  }
                </>
              )
             :
             ( plan.details && <><span>Details:</span> <p>{plan.details}</p></> )}
        </div>)


        if(plan.plan_title === "HomeCare Fest"){
            status = (<div className={styles.plan_details}>
                <span>Details:</span>
                <p className={`${styles.plan_detail_header}`}>{HOMECARE_FEST_MAX_CLAIMS - plan.total_claims}/{HOMECARE_FEST_MAX_CLAIMS} Preventive Maintenance/Breakdown Support available</p>
            </div>)

        } else if(BLOCKED_CHANNELS.includes(plan.channel_name)){
            status = (<div className={styles.plan_details}>
                <span>Details:</span>
                <p>Please contact TATA AIG on 1800-266-7780 for generating a Claim ID and register your Service Request</p>
            </div>)
        }
        else if (isBrandBlocked(plan)) {
            let brand = plan.brand?.toLowerCase()
            if (!brand || brand === 'others' && plan.model){
                brand = getBrandFromModel(plan.model)
            }
            status = (<div className={styles.plan_details}>
                <span>Details:</span>
                <p>No service support for {brand} {plan.category_type}, kindly reach out to the seller for next steps</p>
            </div>)
        }
        return status
    }
    return (
        <Fragment>

            <div className={styles.app_btn}
                data-disabled={props.disabled}
                data-selected={props.is_selected ? props.is_selected : false}
                onClick={(e) => {
                e.preventDefault();
                !props.disabled ? props.onClick(e) : null
            }}>
                {HOMECARE_PLAN_LIST.includes(plan.plan_title)
                    ? <p className={styles.plan_header}>{plan.plan_title}</p>
                    : <p className={styles.plan_header}>{plan.brand} {plan.model} {plan.device_name ? plan.device_name : plan.category_type} ({plan.plan_title})</p>}


                {/* <p className={`${styles.plan_status} ${plan.plan_status.toLocaleLowerCase().replace(/ /g, "_")}`}>{['inspection pending', 'under brand warranty'].includes(plan.plan_status.toLocaleLowerCase())? `Device ${planStatus}`: `Onsitego Plan is ${planStatus}`}</p> */}
                <p className={`${styles.plan_status} ${plan?.plan_status?.toLocaleLowerCase().replace(/ /g, "_")}`}>{statusMapping[capitalize(plan.plan_status)]}</p>

                {plan.plan_eligibility_text &&
                   <p className={`${styles.plan_status} active`}>{plan.plan_eligibility_text}</p>
                }

                {HOMECARE_PLANS.includes(plan.plan_title) ?
                    <div className={styles.plan_details} style={{'marginBottom': '15px'}}>
                        <span>Device Covered:</span>
                        <p>{plan.homecare_device_list}</p>
                    </div>
                 :
                     null
                 }

                {plan.plan_tenure !== 'None to None' && <div className={`${styles.plan_details} ${styles.plan_tenure}`}><span>Plan Tenure: </span><p>{plan.plan_tenure}</p></div>}

                {plan.serial_no && <div className={`${styles.plan_details} ${styles.serial_no}`}><span>Serial Number: </span><p>{plan.serial_no}</p></div>}

                {HOMECARE_PREMIUM_PRODUCTS.includes(plan.plan_name) &&
                <div className={styles.plan_coverage}>
                    <p className={styles.plan_coverage_header}>Plan Coverage Details</p>
                    <div className={styles.plan_coverage_details}>
                        <div className={styles.plan_coverage_details_item}>
                            <div className={styles.check_mark}>
                              <Image width="16" height="16" src={getStaticPath(`/static/images/selfserve/true.svg`)} className={styles.check_mark}/>
                            </div>
                            <span>Registered devices will have comprehensive coverage </span>
                        </div>
                        <div className={styles.plan_coverage_details_item}>
                            <div className={styles.check_mark}>
                              <Image width="16" height="16" src={getStaticPath(`/static/images/selfserve/true.svg`)} />
                            </div>
                            <span>All service and spare parts to have 90-day warranty </span>
                        </div>
                        <div className={styles.plan_coverage_details_item}>
                            <div className={styles.check_mark}>
                              <Image width="16" height="16" src={getStaticPath(`/static/images/selfserve/true.svg`)} />
                            </div>
                            <span>No service fee or visit charge to be levied for any of the devices to be repaired under the plan </span>
                        </div>
                    </div>
                </div>
                }
                {getDetailsComponent(plan)}
            </div>
        </Fragment>
    );

}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect(mapStateToProps) (PlanPage);
